export default class ImageService {

  constructor(Restangular, SessionsService) {
    'ngInject';
    this.Restangular = Restangular;
    this.SessionsService = SessionsService;
  }

  getImages(tenantId) {
    return this.Restangular.oneUrl('image', `${process.env.__backendUrl__}/internal/v1/image/tenant/${tenantId}`).getList()
  }

  saveImage(tenantId, formData) {
    // jQuery ajax used here instead of angular / Restangular due to angular bug with posting form data
    const idToken = this.SessionsService.getIdToken();
    const headers = {Authorization: `Bearer ${idToken}`};
    return $.ajax({
      type: 'POST',
      url: `${process.env.__backendUrl__}/internal/v1/image/tenant/${tenantId}`,
      headers: headers,
      data: formData,
      processData: false,
      contentType: false
    });
  }

  deleteImage(image_id) {
    let promise = this.Restangular.oneUrl('image', `${process.env.__backendUrl__}/internal/v1/image/${image_id}`).remove();
    return promise;
  }


}


